import MobileHomeIcon from './MobileHomeIcon'
export default MobileHomeIcon;
